import { useEffect } from 'react';
import kalibreFontYukle from '../utils/kalibreFont';

/**
 * Yetsan logosu ve program MARKA KİLİDİ: [YETSAN logosu] │ P A N E L
 *
 * Program adı Martian Mono'nun geniş kesimiyle (wdth 112), harf aralıklı yazılır — logonun kalın
 * kırmızı harflerine karşı bir ölçü aleti etiketi gibi durur (DESIGN.md "Kalibre"). Aradaki ince
 * dikey çizgi iki parçayı tek marka yapar. Panel, WMS, MES, CRM ve Sistem Seç aynı kilidi kullanır.
 *
 * Görsel: public/yetsan-logo-kirpik.png (607×112, şeffaf kenarlar kırpılmış). Harf gövdesi
 * yüksekliğin ~%65'i, altı "Y"nin kuyruğu; %13 aşağı kaydırılır ki gövde program adıyla hizalansın.
 *
 * boy: logo yüksekliği (px); program adı boyu buna göre hesaplanır.
 * sistem: program adı (büyük harf, şablonda yazılır — CSS ile büyütülmez).
 * beyaz: koyu zeminde beyaz logo + beyaz ad. renk: açık zeminde ad rengi (varsayılan petrol).
 */
export default function YetsanLogo({ boy = 20, sistem, beyaz = false, renk = '#0E3A46', className = '' }) {
  useEffect(() => { if (sistem) kalibreFontYukle(); }, [sistem]);
  const logo = (
    <img src="/yetsan-logo-kirpik.png" alt="YETSAN" draggable="false" width="607" height="112"
      style={{ height: boy, width: 'auto', transform: 'translateY(13%)' }}
      className={`shrink-0 select-none ${beyaz ? 'brightness-0 invert' : ''}`}
      onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = '/yetsan-logo-yatay.png'; }} />
  );
  if (!sistem) return <span className={`inline-flex items-center ${className}`}>{logo}</span>;
  const ad = Math.round(boy * 0.62);
  return (
    <span className={`inline-flex items-center ${className}`} aria-label={`YETSAN ${sistem}`}>
      {logo}
      <span aria-hidden="true" style={{ width: 1, height: Math.round(boy * 0.95), margin: `0 ${Math.round(boy * 0.5)}px`,
        background: beyaz ? 'rgba(255,255,255,0.45)' : 'rgba(14,58,70,0.28)' }} />
      <span aria-hidden="true" style={{
        fontFamily: "'Martian Mono', ui-monospace, 'SF Mono', Menlo, monospace", fontStretch: '112%',
        fontWeight: 600, fontSize: ad, lineHeight: 1, letterSpacing: '0.2em', marginRight: '-0.2em',
        color: beyaz ? '#FFFFFF' : renk, whiteSpace: 'nowrap',
      }}>{sistem}</span>
    </span>
  );
}
